import { useLayoutEffect, useRef, useState } from 'react'

const listeners = new Map<Element, () => void>()

let sharedObserver: ResizeObserver | undefined

const getSharedObserver = () => {
  if (!sharedObserver) {
    sharedObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        listeners.get(entry.target)?.()
      }
    })
  }
  return sharedObserver
}

export const useIsTruncated = (text: string) => {
  const ref = useRef<HTMLElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    const measure = () => {
      setIsTruncated(element.scrollWidth > element.clientWidth)
    }

    measure()
    listeners.set(element, measure)
    const observer = getSharedObserver()
    observer.observe(element)
    return () => {
      observer.unobserve(element)
      listeners.delete(element)
    }
  }, [text])

  return { ref, isTruncated }
}
